import React from "react";
import { object } from "prop-types";
import { Table } from "reactstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import { clientScoringResultScoringStatusOptions } from "../../../../monitoring-queue-entry/constants/clientScoringResultConstants";
import DocumentIcon from "../../../../../assets/DocumentIcon";
import ReactTooltip from "react-tooltip";

const ScoringResultHistoryTable = ({ singleClientReportDetails }) => {
  const getScoringStatusLabel = (status) =>
    clientScoringResultScoringStatusOptions.find(
      (option) => option.value === status
    ).label;

  const rows =
    singleClientReportDetails.clientScoringResultHistory != null
      ? singleClientReportDetails.clientScoringResultHistory.map(
          (entry, index) => {
            return (
              <tr key={index}>
                <td className="font-weight-bolder">
                  {getScoringStatusLabel(entry.oldScoringStatus)}
                </td>
                <td className="font-weight-bolder">
                  {getScoringStatusLabel(entry.newScoringStatus)}
                </td>
                <td>
                  {moment
                    .utc(entry.createDate)
                    .local()
                    .format("DD.MM.YYYY HH:mm:ss")}
                </td>
                <td>{entry.createdByUser.name}</td>
                <td>{entry.userRoleName}</td>
                    <td>{entry.comment}</td>
                <td className="text-center">
                  <Link
                    to={`?monitoringQueueEntryDetails&entryID=${entry.monitoringQueueId}&type=null`}
                    data-tip
                    data-for="report-icon"
                  >
                    <DocumentIcon />
                  </Link>
                  <ReactTooltip id="report-icon" type="info" effect="solid">
                    <span>Open</span>
                  </ReactTooltip>
                </td>
              </tr>
            );
          }
        )
      : "";
  return (
    <Table className="single-client-report-entries-table">
      <thead>
        <tr>
          <th>{singleClientReportDetails.oldScoringResultDecisionLabel}</th>
          <th>{singleClientReportDetails.newScoringResultDecisionLabel}</th>
          <th>{singleClientReportDetails.dateLabel}</th>
          <th>{singleClientReportDetails.userLabel}</th>
          <th>{singleClientReportDetails.userRoleLabel}</th>
          <th>{singleClientReportDetails.commentLabel}</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>{rows}</tbody>
      <tfoot />
    </Table>
  );
};

ScoringResultHistoryTable.propTypes = {
  singleClientReportDetails: object.isRequired,
};

export default ScoringResultHistoryTable;



// WEBPACK FOOTER //
// ./src/features/reports/components/single-client-details/scoring-result-history-table/ScoringResultHistoryTable.jsx